(function($) {

var pageId = 'page-inbox',
    page = '#' + pageId;

$(function() {

    $(document).on('ajax:success', '.inbox-del', function(e, result) {
        var inbox_mail = $(this).closest('.mail');

        if (result.success) {
            inbox_mail.slideUp();
        }
    });

});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    tower.scrollLoad($page, function() {
        return $.ajax({
            url: location.pathname,
            dataType: 'html',
            type: 'get',
            data: {
                last_mail_id: $('.mail:last').data('guid')
            },
            success: function( result ) {
                if ( result ) {
                    $('.mails').append(result);
                    tower.adjustReadableTime();
                }
            }
        });
    });
});


})(jQuery);

